{
  "COMPLEX": "Fiducie complexe",
  "SIMPLE": "Fiducie simple",
  "GRANTOR": "Fiducie de cédant"
}
